export default __webpack_public_path__ + "static/media/intro_vid.5d18a2fd.mp4";